// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function StoreDetails() {

//   const { slug } = useParams();
//   const navigate = useNavigate();

//   const [store, setStore] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//   axios
//     .get("https://onlinepk.me/admin/api/stores")
//     .then((response) => {
//       const stores = response.data.data || response.data;

//       const selectedStore = stores.find((item) => {
//         const itemSlug = item.name
//           .toLowerCase()
//           .trim()
//           .replace(/\s+/g, "-")
//           .replace(/[^a-z0-9-]/g, "");

//         return itemSlug === slug;
//       });

//       setStore(selectedStore || null);
//     })
//     .catch((err) => {
//       console.error(err);
//       setStore(null);
//     })
//     .finally(() => setLoading(false));
// }, [slug]);

// const getImage = () => {
//   if (!store) return "/no-image.png";

//   if (store.image_url) return store.image_url;

//   if (store.img) {
//     return `https://onlinepk.me/admin/upload/stores/{slug}`;
//   }

//   return "/no-image.png";
// };
//   if (loading) {
//     return <h3 className="text-center mt-5">Loading...</h3>;
//   }

//   if (!store) {
//     return <h3 className="text-center mt-5">No Store Found</h3>;
//   }

//   return (
//     <div className="container mt-4">

//       <button
//         className="btn btn-success mb-3"
//         onClick={() => navigate(-1)}
//       >
//         Back
//       </button>

//       <div className="card shadow">

//         <img
//           src={getImage()}
//           alt={store.name}
//           className="card-img-top"
//           style={{
//             height: "300px",
//             objectFit: "cover"
//           }}
//           onError={(e) => {
//             e.target.src = "/no-image.png";
//           }}
//         />

//         <div className="card-body">

//           <h2>{store.name}</h2>

//           <p><strong>Address:</strong> {store.address || "N/A"}</p>

//           <p><strong>Phone:</strong> {store.phone || "N/A"}</p>

//           <p><strong>Open Time:</strong> {store.open_time || "N/A"}</p>

//           <p><strong>Close Time:</strong> {store.close_time || "N/A"}</p>

//         </div>

//       </div>

//     </div>
//   );
// }


// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function StoreDetails() {
//   const { slug } = useParams();
//   const navigate = useNavigate();

//   const [store, setStore] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     setLoading(true);

//     axios
    
//       .get(`https://onlinepk.me/admin/api/stores`)
//       .then((response) => {
//         setStore(response.data.data);
//       })
//       .catch((err) => {
//         console.log(err);
//         setStore(null);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [slug]);

//   if (loading) {
//     return (
//       <div className="container mt-5 text-center">
//         <h3>Loading...</h3>
//       </div>
//     );
//   }

//   if (!store) {
//     return (
//       <div className="container mt-5 text-center">
//         <h3>No Store Found</h3>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4">

//       <button
//         className="btn btn-success mb-3"
//         onClick={() => navigate(-1)}
//       >
//         ← Back
//       </button>

//       <div className="card shadow">

//         <img
//           src={store.image_url || "/no-image.png"}
//           alt={store.name}
//           className="card-img-top"
//           style={{
//             height: "350px",
//             objectFit: "cover"
//           }}
//           onError={(e) => {
//             e.target.src = "/no-image.png";
//           }}
//         />

//         <div className="card-body">

//           <h2>{store.name}</h2>

//           <p>
//             <strong>Address:</strong> {store.address}
//           </p>

//           <p>
//             <strong>Phone:</strong> {store.phone}
//           </p>

//           <p>
//             <strong>Open Time:</strong> {store.open_time}
//           </p>

//           <p>
//             <strong>Close Time:</strong> {store.close_time}
//           </p>

//         </div>

//       </div>

//     </div>
//   );
// }

// // import { useEffect, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";

// // export default function StoreDetails() {

// //   const { slug } = useParams();
// //   const navigate = useNavigate();

// //   const [store, setStore] = useState(null);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {

// //     loadStore();

// //   }, [slug]);

// //   const loadStore = async () => {

// //     try {

// //       setLoading(true);

// //       const res = await axios.get(
// //         `https://onlinepk.me/admin/api/store/${slug}`
// //       );

// //       setStore(res.data.data);

// //     } catch (err) {

// //       console.log(err);

// //       setStore(null);

// //     } finally {

// //       setLoading(false);

// //     }

// //   };

// //   if (loading) {

// //     return (
// //       <div className="text-center mt-5">
// //         <h3>Loading...</h3>
// //       </div>
// //     );

// //   }

// //   if (!store) {

// //     return (
// //       <div className="text-center mt-5">

// //         <h3>No Store Found</h3>

// //         <button
// //           className="btn btn-success mt-3"
// //           onClick={() => navigate("/store")}
// //         >
// //           Back
// //         </button>

// //       </div>
// //     );

// //   }

// //   return (

// //     <div className="container mt-4">

// //       <button
// //         className="btn btn-success mb-3"
// //         onClick={() => navigate(-1)}
// //       >
// //         ← Back
// //       </button>

// //       <div className="card shadow">

// //         <img
// //           src={store.image_url}
// //           alt={store.name}
// //           className="card-img-top"
// //           style={{
// //             height: "350px",
// //             objectFit: "cover"
// //           }}
// //           onError={(e)=>{
// //             e.target.src="/no-image.png";
// //           }}
// //         />

// //         <div className="card-body">

// //           <h2>{store.name}</h2>

// //           <hr/>

// //           <p>
// //             <strong>Address :</strong> {store.address}
// //           </p>

// //           <p>
// //             <strong>Phone :</strong> {store.phone}
// //           </p>

// //           <p>
// //             <strong>Email :</strong> {store.email}
// //           </p>

// //           <p>
// //             <strong>Open :</strong> {store.open_time}
// //           </p>

// //           <p>
// //             <strong>Close :</strong> {store.close_time}
// //           </p>

// //         </div>

// //       </div>

// //     </div>

// //   );

// // }

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function StoreDetails() {

  const { slug } = useParams();

  const [store, setStore] = useState(null);

 useEffect(() => {
  axios
    .get("https://onlinepk.me/admin/api/stores")
    .then((res) => {

      console.log("URL Slug:", slug);
      console.log("API:", res.data);

      const foundStore = res.data.find(
        item => item.slug?.trim() === slug?.trim()
      );

      console.log("Found:", foundStore);

      setStore(foundStore || null);
    })
    .catch(console.error);

}, [slug]);
const getImage = (store) => {
  const img =
    store?.image_url ||
    store?.image ||
    store?.logo ||
    store?.img;

  if (!img) return "/no-image.png";

  if (img.startsWith("http")) return img;

  return `https://onlinepk.me/admin/upload/store/${img}`;
};

  if (!store) return <h2>Loading...</h2>;

  return (

    <div className="container py-5">

      <div className="card shadow">

        <img
  src={getImage(store)}
  alt={store.name}
  className="card-img-top"
  style={{
    height: "350px",
    objectFit: "cover",
  }}
  onError={(e) => {
    e.target.src = "/no-image.png";
  }}
/>

        <div className="card-body">

          <h2>{store.name}</h2>

          <p><b>Phone:</b> {store.phone}</p>

          <p><b>Address:</b> {store.address}</p>

          <p><b>Whatsapp:</b> {store.whatsapp}</p>

          <p><b>Delivery Charges:</b> Rs. {store.delivery_charges}</p>

          <p><b>Minimum Order:</b> Rs. {store.min_delivery_amount}</p>

          <p><b>Open Time:</b> {store.open_time}</p>

          <p><b>Close Time:</b> {store.close_time}</p>

          <p><b>Delivery Time:</b> {store.delivery_time} {store.unit}</p>

        </div>

      </div>

    </div>

  );

}